import { render } from "./DashNavigatorAdmin.vue?vue&type=template&id=006a1b20"
import script from "./DashNavigatorAdmin.vue?vue&type=script&lang=js"
export * from "./DashNavigatorAdmin.vue?vue&type=script&lang=js"

import "./DashNavigatorAdmin.vue?vue&type=style&index=0&id=006a1b20&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__